module.exports = "<footer class=\"text-muted\">\n  <div class=\"container\">\n   \n    <p class=\"text-muted\">\n        &copy; 2017-2018 {{'Development United' | translate}}\n    </p>\n  </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/layout/footer.component.html
// module id = ../../../../../src/app/shared/layout/footer.component.html
// module chunks = main